import { useState } from "react";
import { Button, Modal } from "antd";

import * as S from "./styles";

export const UpdateStorePasswordModal = ({ open, onCancel, onSubmit }) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      setLoadingSubmit(true);

      const formData = new FormData(e.currentTarget);

      const newPassword = formData.get("newPassword").toString();

      await onSubmit({
        newPassword,
      });
    } catch (error) {
      console.error("failed to update store password", error);
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <Modal
      title="Atualizar Senha"
      open={open}
      onCancel={onCancel}
      cancelText="Cancelar"
      destroyOnClose={true}
      closable={false}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
    >
      <S.Container onSubmit={handleSubmit}>
        <input type="text" name="newPassword" placeholder="Nova Senha" />
        <Button
          type="primary"
          htmlType="submit"
          disabled={loadingSubmit}
          id="app-button"
        >
          {loadingSubmit ? "Carregando..." : "Atualizar"}
        </Button>
      </S.Container>
    </Modal>
  );
};
